import { AccountArrowLeftOutlineIcon } from './AccountArrowLeftOutlineIcon';

/**
 * author: Coffeemate
 * id D46BABF7-60F1-41B8-BE5E-5D52367FE58C
 * name account-arrow-left-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-left-outline.svg
 * tags
 * - Account / User 
 */
export const PersonArrowLeftOutlineIcon = AccountArrowLeftOutlineIcon;
export default PersonArrowLeftOutlineIcon